/** The Invoices list keeps its group, search and page in the address, so Back lands in the same place. */
import { z } from 'zod'
import { type InvoicesQuery, invoiceGroups } from '@/core/invoices'

export const invoicesSearchSchema = z.object({
  group: z.enum(invoiceGroups).optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  page: z.coerce.number().int().min(1).optional().catch(undefined),
  view: z.literal('deleted').optional().catch(undefined),
  // Only invoices imported as unpaid and not yet checked (Today's link, the import's done page).
  imported: z.literal('unpaid').optional().catch(undefined),
})
export type InvoicesSearch = z.infer<typeof invoicesSearchSchema>

export const PAGE_SIZE = 25

export function queryFromSearch(search: InvoicesSearch): InvoicesQuery {
  return {
    group: search.group ?? 'action',
    q: search.q ?? '',
    page: search.page ?? 1,
    pageSize: PAGE_SIZE,
    ...(search.imported ? { imported: search.imported } : {}),
  }
}
